// extracted by mini-css-extract-plugin
export default {"topic-container":"Legal_topic-container__u27Qk","topic-header":"Legal_topic-header__q8Crq","topic-content":"Legal_topic-content__aoryp"};